// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"8de6edbe","513":"7f06fcb4","703":"79f20345"}[chunkId] + ".chunk.js";
};